<template>
  <div>
    <template v-if="details">
      <v-layout wrap>
        <v-flex
          md4
          xs12
        >
          <v-card
            class="ma-1"
          >
            <v-container>
              <div>
                <span class="text-caption">{{ $t('tasks.state.name') + ': ' }}</span>
                {{ details.state | taskState }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.priority.name') + ': ' }}</span>
                {{ details.priority | taskPriority }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.assigned_user') + ': ' }}</span>
                {{ details.assigned_user | fullName }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.time_spent') + ': ' }}</span>
                {{ details.time_entries | timeEntriesSumHumanize }}
              </div>
              <v-divider
                class="my-2"
              />
              <div>
                <span class="text-caption">{{
                  $t('tasks.preparePackage.subordinate_stock_id') + ': '
                }}</span>
                {{ details.subordinate_stock.name }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.preparePackage.location') + ': ' }}</span>
                {{ details.stock_location.name }}
              </div>
              <div>
                <span class="text-caption">{{
                  $t('stocks.substocks.prepare_package_mode') + ': '
                }}</span>
                {{
                  $t('stocks.substocks.prepare_package_mode_items.' + details.subordinate_stock.prepare_package_mode)
                }}
              </div>
              <div v-show="details.description">
                <span class="text-caption">{{ $t('tasks.description') + ': ' }}</span>
                {{ details.description }}
              </div>
              <v-divider
                class="my-2"
              />
              <EntityHistory :changes="details" />
            </v-container>
          </v-card>
        </v-flex>
        <v-flex
          v-show="details.notes.length > 0"
          md4
          xs12
        >
          <Notes :notes="details.notes" />
        </v-flex>
        <v-flex
          md4
          xs12
        >
          <TaskAttachments
            :attachments="details.attachments"
          />
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-progress-linear
        indeterminate
      />
    </template>
  </div>
</template>

<script>
    import EntityHistory from "@/app/components/EntityHistory.component";
    import TaskAttachments from "@/app/tasks/components/TaskAttachments.component";
    import Notes from "@/app/tasks/components/TaskNotes.component";

    export default {
        name: "PreparePackageAssignment",
        components: {EntityHistory, TaskAttachments, Notes},
        props: {
            taskInfo: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            details: function () {
                return this.taskInfo.details;
            }
        }
    };
</script>

<style scoped>

</style>
